<template>
  <div style="background-color:#f4f5f5; height:750px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false" @click-left="onClickLeft">
          <template #left>
            <van-icon style=" font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <span style="color:#FFFFFF; font-weight: 700; font-size: 19px;">優惠卡券</span>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <van-empty description="暫無折扣券" />
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onSubmit () {
    },
    onClickLeft () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Coupon.vue